import { ModifierWidgetV2 } from '@/common'
import useI18n from '@/shared/hooks/usei18n'

export function CscfControl({
  value,
  onChange,
  onMouseUp
}: {
  value: number
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  onMouseUp?: (evt: React.SyntheticEvent<HTMLInputElement>) => void
}) {
  const { t } = useI18n()

  return (
    <ModifierWidgetV2
      title={t('common:cscf.label')}
      tooltip={t('common:cscf.tooltip')}
      value={value}
      sliderControls={{
        min: 0,
        max: 100,
        step: 1
      }}
      formatValue={value => `${value}%`}
      onChange={onChange}
      onMouseUp={onMouseUp}
    />
  )
}
